import { resTol } from '@/tools/public';
export default {
  name: 'DataPickerCpt',
  components: {},
  props: {
    request: {
      type: [Object, Function]
    },
    requestParameter: {
      type: [Object],
      default() {
        return {};
      }
    },
    columnsFieldNames: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      show: false,
      isLoading: false,
      dataRes: [],
      dataValueKey: this.valueKey,
      dataRequest: this.request,
      dataRequestParameter: this.requestParameter
    };
  },
  methods: {
    showView(valueKey, request, requestParameter) {
      if (valueKey) {
        this.dataValueKey = valueKey;
      }
      if (request) {
        this.dataRequest = request;
      }
      if (requestParameter) {
        this.dataRequestParameter = requestParameter;
      }
      this.show = true;
      this.isLoading = true;
      resTol.initReqResCb(this.dataRes, this.dataRequest, this.dataRequestParameter, res => {
        this.dataRes = res;
        this.isLoading = false;
      });
    },
    onConfirmClick({
      selectedValues,
      selectedOptions
    }) {
      this.$emit('onSelectedChange', selectedValues, selectedOptions);
      this.show = false;
    },
    onCancelClick() {
      this.show = false;
    }
  }
};